const formatPrice = (price) => {
  let priceToFormat;

  // Extract the formattedPrice property when the price is passed as an object with formattedPrice and geoTaxDisclosure.
  if (price?.formattedPrice) {
    priceToFormat = price.formattedPrice;
  } else if (typeof price === 'string') {
    priceToFormat = price;
  } else {
    return '';
  }

  if (priceToFormat) {
    // Remove trailing 00s after commas or dots if they are followed by:
    // whitespace, a non-word character, or the end of the string
    // example: $450.00 becomes $450
    return priceToFormat.replace(/[,|.]00(?=\s|\W|$)/g, '');
  }
  return '';
};

export default formatPrice;
